'use client';

import { useGetContactChannel } from '@/api/generated/contact-channel/contact-channel';
import { PropsWithChildren } from 'react';
import { addBase, createSuperContext } from 'superctx';
type ContactChannelContextValue = {
  url: string | null;
  isLoading: boolean;
};
export const ContactChannel = addBase(createSuperContext<ContactChannelContextValue>({
  notProvidedMessage: 'ContactChannel must be used within a ContactChannelProvider'
}), Provider => function ContactChannelProvider({
  children
}: PropsWithChildren) {
  const {
    data,
    isLoading
  } = useGetContactChannel();
  const url = data?.url ?? null;
  return <Provider value={{
    url,
    isLoading
  }}>{children}</Provider>;
});